@if (product && qty) {
<div class="flex flex-middle m-b">
    <div class="ratio-1-1"
         style="width: 36px">
        <img class="rf"
             image="/assets/images/pdp-delivery.png">
    </div>
    <div class="p-l-2"
         style="width: calc(100% - 36px);">
        <span [ngClass]="!isSalable ? 'col-2 stock-pdp' :  isInStock? 'col-3 stock-pdp' : ''">
            @if (!isMattressWithSimbaBeds) {
            <span class="p2">
                {{displayedStockDescription}}@if(showMadeToOrderInfoModalButton){.
                <span class="inline-block underline cursor-pointer"
                      style="text-underline-offset: 2px;"
                      [iCmsModalOpen]="'made-to-order-info-modal'">
                    Tell me more >
                </span>
                }
            </span>
            }
            @if (isMattressWithSimbaBeds) {
            <span class="p2">{{'Delivered within 3 working days' | translate}}</span>
            }
        </span>
        @if (stockDescription && isInStock) {
        <span class="c1 m-t--1 m-l-1">{{stockDescription}}</span>
        }
        @if (displayMaxQtyMessage) {
        <p class="c1">{{'Only % of this product % remaining' | translate : maxQty : (maxQty
            === 1 ? 'is' : 'are')}}</p>
        }
    </div>
</div>
}
